// api/userService.js
import apiClient from '../../../api/apiClient';

// Update your user service function
/*export const fetchUsers = async (params = {}) => {
    try {
      const response = await apiClient.get("/users", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };*/

  export const fetchUsers = async ({ search }) => {
    try {
      const response = await apiClient.get(`/users?search=${search}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw new Error("Failed to fetch users.");
    }
  };

export const updateUser = async (userId, userData) => {
  try {
    const response = await apiClient.put(`/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw new Error("Failed to update user");
  }
};